"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createText;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function createText(_param) {
    var { text = "", position = {
        x: 0,
        y: 0
    }, offset = {
        x: 0,
        y: 0
    }, rotation = 0, onDoubleClick = ()=>{} } = _param, rest = _object_without_properties(_param, [
        "text",
        "position",
        "offset",
        "rotation",
        "onDoubleClick"
    ]);
    const textNode = new _konva.default.Text(_object_spread({
        x: position.x,
        y: position.y,
        offsetX: offset.x,
        offsetY: offset.y,
        text: text,
        rotation: rotation,
        fontSize: 14,
        fontFamily: "Arial",
        fill: "white",
        fontStyle: "bold",
        verticalAlign: "top",
        fillAfterStrokeEnabled: true,
        perfectDrawEnabled: false
    }, rest));
    if (onDoubleClick) {
        textNode.on("dblclick dbltap", (e)=>{
            onDoubleClick(e);
        });
    }
    return textNode;
}
